export const addDriverFieldsList = [
    {
      name: 'name',
      label: 'Name',
    },
    {
      name: 'worker_code',
      label: 'Worker Code',
    },
    {
      name: 'phone',
      label: 'Phone',
    },
    {
      name: 'identification_documents',
      label: 'Identification Documents',
    },
    {
      name: 'username',
      label: 'Username',
    },
    {
      name: 'password',
      label: 'Password',
    },
    {
      name: 'passwordCon',
      label: 'Confirm Password',
      key: 'password',
    },
    {
      name: 'hub_code',
      label: 'Hub Code',
    },
    {
      name: 'gender',
      label: 'Gender',
    },
    {
      name: 'is_active',
      label: 'Active',
    },
    {
      name: 'pincode',
      label: 'Pincode',
    },
    {
      name: 'vendor_code',
      label: 'Vendor Code',
    },
    {
      name: 'license_category_list',
      label: 'License category list',
    },
    {
      name: 'city',
      label: 'City',
    },
    {
      name: 'state',
      label: 'State',
    },
    {
      name: 'country',
      label: 'Country',
    },
    {
      name: 'driving_licence_validity',
      label: 'Driving Licence Validity',
    },
    {
      name: 'driving_licence_number',
      label: 'Driving Licence Number',
    },
    {
      name: 'available_for_trip_action',
      label: 'Available for Trip action',
    },
];

export const genderList = [
    {
      key: 'Male',
      value: 'male',
    },
    {
      key: 'Female',
      value: 'female',
    },
    {
      key: 'Not Specified',
      value: 'not_specified',
    },
];

export const addRiderLocationFields = [
  'pincode',
  'city',
  'state',
  'country',
];

export const addRiderTailLayout = {
    wrapperCol: { offset: 18, span: 6 },
};

export const addRiderFormItemLayout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
};

interface VehicleMakeMapping {
  vehicle_make_code: string;
  vehicle_make_name: string;
  vehicle_vendor_code: string;
  quantity: number;
  vehicle_make_id: string;
}

export interface VendorDetails {
  id: string;
  code: string;
  name: string;
  vehicle_make_mapping: VehicleMakeMapping[];
}

export interface HubDetails {
  id: string;
  name: string;
  code: string;
  parent_hub_id: string | null;
  hub_type: string;
  routing_strategy_id: string | null;
  use_green_deployment: boolean;
  route_optimization_time_slots: string | null;
  is_physical_drs_disabled: boolean;
  hub_loc: [number, number];
  hub_level: number;
  category_name: string;
}

export interface IdentificationDocument {
  type: string;
  image?: string;
  number?: string;
  signedUrl?: string;
}
